import React from 'react';

const OfferStageTranslationsContext = React.createContext(trKey => trKey);
export const OfferStageTranslationsContextProvider = OfferStageTranslationsContext.Provider;
export default OfferStageTranslationsContext;